import { appBrandPalettes, appNeutralPalette } from "./palette";

export type AppShadowTokens = {
  appCardShadow: string;
  appCardShadow2: string;
  appCardShadowHover: string;
};

// Только для карточек редизайна; стандартные тени компонентов рассчитывает AntD.
export const appCardShadows: Record<"light" | "dark", AppShadowTokens> = {
  light: {
    appCardShadow: `0 2px 4px ${appNeutralPalette[2]}, 0 10px 28px ${appNeutralPalette[2]}`,
    appCardShadow2: `0 4px 10px 0 ${appNeutralPalette[2]}4D`,
    appCardShadowHover: `0 4px 8px ${appNeutralPalette[2]}, 0 16px 36px ${appNeutralPalette[2]}`,
  },
  dark: {
    appCardShadow: `0 8px 24px ${appNeutralPalette[9]}, 0 0 24px ${appBrandPalettes.dark[0]}`,
    appCardShadow2: `0 4px 10px 0 ${appNeutralPalette[9]}80`,
    appCardShadowHover: `0 12px 32px ${appNeutralPalette[9]}, 0 0 28px ${appBrandPalettes.dark[0]}`,
  },
};
